import { useEffect, useMemo, useState } from 'react';

import { ColorByType } from 'api/queries/getPoapPrimaryViews.query';

import { SchedulerControls } from 'components/common/bryntumScheduler/SchedulerControlsHook';

import { UseViewsManagerProvider } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager.provider';
import { COLOR_BY_OPTIONS } from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/components/ViewControlsBar/ViewControlsBar';
import { useScheduleViewIdUrlState } from 'components/pages/ScheduleViewsPage/hooks/useScheduleViewIdUrlState';

interface Props {
    api: UseViewsManagerProvider['api'];
    update: (patch: Partial<SchedulerControls>) => void;
}
export const useViewConfigurationLogic = ({ api, update }: Props) => {
    const [viewId] = useScheduleViewIdUrlState();
    const [showControls, setShowControls] = useState(true);

    const primaryItems = api.getPrimaryViews.instance.data;
    const selectedView = useMemo(() => {
        return primaryItems?.find((item) => item.viewId === Number(viewId));
    }, [primaryItems, viewId]);

    const [showBaseline, setShowBaseline] = useState(false);
    const [showLabels, setShowLabels] = useState(false);
    const [colorBy, setColorBy] = useState<ColorByType>(COLOR_BY_OPTIONS[0].value);

    useEffect(() => {
        // Intialize the controls state based on the selected view's settings when the view changes
        if (selectedView) {
            const initialShowBaselineValue = selectedView.showBaseline ?? false;
            const initialShowLabelsValue = selectedView.showlabels ?? true;
            const initialColorByValue = selectedView.colorBy ?? COLOR_BY_OPTIONS[0].value;
            setShowBaseline(initialShowBaselineValue);
            setShowLabels(initialShowLabelsValue);
            setColorBy(selectedView.colorBy ?? COLOR_BY_OPTIONS[0].value);
            update({
                comparisonMode: initialShowBaselineValue ? 'baseline' : 'none',
                isShowLabels: initialShowLabelsValue,
                colorByMode: initialColorByValue,
            });
        }
    }, [selectedView]);

    return {
        logic: {
            viewId: Number(viewId),
            viewName: selectedView?.viewName,
            isViewOwner: selectedView?.isOwner ?? false,
            setShowControls,
            showControls,
            colorBy,
            showBaseline,
            showLabels,
            setShowBaseline,
            setShowLabels,
            setColorBy,
        },
    };
};
